module.exports = {
  returnNameForId: {
    1: 'DEPENDENTE',
    2: 'TITULAR',
  },
  returnIdForName: {
    DEPENDENTE: 1,
    TITULAR: 2,
  },
  returnIdForNameFormatted: {
    Dependente: 1,
    Titular: 2,
  },
  returnNameFormattedForId: {
    1: 'Dependente',
    2: 'Titular',
  },
  returnNameFormattedForName: {
    DEPENDENTE: 'Dependente',
    TITULAR: 'Titular',
  },
  returnNameForNameFormatted: {
    Dependente: 'DEPENDENTE',
    Titular: 'TITULAR',
  },
};
